/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Plan_SubmitInputs */

const cs_billing_plan_submit = /** @type {(inputs: Billing_Plan_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nastavit tarif`)
};

const en_billing_plan_submit = /** @type {(inputs: Billing_Plan_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assign plan`)
};

/**
* | output |
* | --- |
* | "Assign plan" |
*
* @param {Billing_Plan_SubmitInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_plan_submit = /** @type {((inputs?: Billing_Plan_SubmitInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Plan_SubmitInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_plan_submit(inputs)
	return cs_billing_plan_submit(inputs)
});